"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewDiscountItem = void 0;
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var UniqueId_1 = __importDefault(require("@CommonFrontendBackend/Utils/UniqueId"));
var createNewDiscountItem = function () {
    return {
        id: (0, UniqueId_1.default)(),
        name: "",
        type: Types_1.DiscountType.Percent,
        amount: 0,
        isEnabled: false,
        isDeleted: false,
    };
};
exports.createNewDiscountItem = createNewDiscountItem;
